import React from 'react';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import CommerInfo from '../../CommerInfo';
import { useFusionFeatures } from '../../../hooks/useFusionFeatures';
import './FusionFeatures.scss';

const FusionFeatures = ({ selectedProduct, taggingInfo }) => {
  const {
    tv, phone, internet, smartphoneIncluded,
  } = useFusionFeatures(selectedProduct);

  return (
    <section className="fusion-feat">
      <div className="fusion-feat__title">
        <TextInfo
          text={selectedProduct.dataMap.ctz_claimPrincipal}
          kind={KIND_TEXT.PARAGRAPH}
          align={ALIGN.LEFT}
          color={COLOR.GREY_5}
          size={SIZE.TITLE3}
          fontType={FONT_TYPE.LIGHT}
        />
      </div>
      {smartphoneIncluded && (
      <CommerInfo
        feature={smartphoneIncluded}
        taggingInfo={taggingInfo}
        selectedProduct={selectedProduct}
      />
      )}
      {tv && (
      <CommerInfo
        feature={tv}
        taggingInfo={taggingInfo}
        selectedProduct={selectedProduct}
      />
      )}
      {phone && (
      <CommerInfo
        feature={phone}
        taggingInfo={taggingInfo}
        selectedProduct={selectedProduct}
      />
      )}
      {internet && (
      <CommerInfo
        feature={internet}
        taggingInfo={taggingInfo}
        selectedProduct={selectedProduct}
      />
      )}
    </section>
  );
};

export default FusionFeatures;
